import AXIOS from '@/axios-instance';

export default {

  addConnectedRessource(ressource) {
    return AXIOS.post("/connectedRessource", ressource);
  },
  retrieveConnectedRessource(type) {
    return AXIOS.get("/connectedRessource/ressourceType/"+type);
  },
  retrieveConnectedRessources() {
    return AXIOS.get("/connectedRessource");
  },
  updateConnectedRessource(ressource){
    return AXIOS.put("/connectedRessource", ressource);
  },
  saveRessourceForModelElement(ressourceModelElement){
      return AXIOS.post("/connectRessourceToModelElement", ressourceModelElement);
  },
  retrieveRessourceForModelElements(ressourceId){
      return AXIOS.get("/connectRessourceToModelElement/ressourceId/"+ressourceId)
  },
  deleteRessourceForModelElements(elementId){
      return AXIOS.delete("/connectRessourceToModelElement/element/"+elementId)
  },
  deleteConnectedRessource(ressourceId){
    return AXIOS.delete("/connectedRessource/" + ressourceId);
  },
  getRoleCharacteristicTypes() {
    return AXIOS.get("/connectedRessource/role/characteristic/types");
  },
  addDescriptor(desc){
    return AXIOS.post("/connectedRessource/role/characteristic/descriptor", desc)
  },
  addRoleCharacteristic(char){
    return AXIOS.post("/connectedRessource/role/characteristic", char);
  },
  updateRoleCharacteristic(char){
    return AXIOS.put("/connectedRessource/role/characteristic", char);
  },
  getRoleCharacteristic(roleId){
    return AXIOS.get("/connectedRessource/role/characteristic/"+roleId);
  },
  addRoleCharacteristicAssessment(roleId, assesments){
    return AXIOS.post("/connectedRessource/role/characteristic/assessment/"+roleId, assesments);
  },
  updateRoleCharacteristicAssessment(roleId, assesments){
    return AXIOS.put("/connectedRessource/role/characteristic/assessment/"+roleId, assesments);
  },
  getRoleCharacteristicAssessment(roleId){
    return AXIOS.get("/connectedRessource/role/characteristic/assessment/"+roleId);
  }
}